import { IFrameCollection } from "../../ui";
export const loadedFrames: IFrameCollection = {};
